import { useState } from 'react';
import './library.css';
import { books } from '../../data/books';
import { Link } from 'react-router-dom';
import bookshelf from '../../assets/bookshelf.png'

const categories = ['All', 'Biography', 'Business', 'Creativity', 'Life', 'Productivity', 'Social'];

function LibraryHome() {
  const [activeFilter, setActiveFilter] = useState('All');

  const filteredBooks =
    activeFilter === 'All'
      ? books
      : books.filter((book) => book.categories.includes(activeFilter));

  return (
    <div className="library-page">
      {/* Hero Section */}
      <section className="library-hero">
        <div className="library-hero-text">
          <h1>Loubna's Library</h1>
          <p>
            I enjoy reading and like to keep notes and takeouts. <br />
            Here's my take on some of the books I've read.
          </p>
        </div>
        <div className="library-hero-img">
          <img src={bookshelf} alt="books icon" />
        </div>
      </section>

      {/* Recent Books Section */}
      <section className="recent-books container">
        <h2>Recent Books</h2>
        <div className="book-filters">
          {categories.map((category) => (
            <button
              key={category}
              className={`filter-btn ${activeFilter === category ? 'active' : ''}`}
              onClick={() => setActiveFilter(category)}
            >
              {category}
            </button>
          ))}
        </div>
        <div className="book-card-grid">
          {filteredBooks.map((book) => (
            <div className="book-card" key={book.slug}>
              <img src={book.cover} alt={book.title} />
              <div className="book-card-text">
                <h3>{book.title}</h3>
                <p className="book-author">{book.author}</p>
                <span className="book-tag">{book.category}</span>
                <Link to={`/library/${book.slug}`} className="read-more-link">
                  Read More →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default LibraryHome;